export default {
    _Pop_Sparkle_01: 'Pop_Sparkle_01',
    _land2: 'land2',
    _click_Copy: 'click Copy',
    _glass_07: 'glass_07',
    _Ho_Ho_Ho: 'Ho_Ho_Ho',
    _Sound_2__Deck_the_Halls__Christmas_WS: 'Sound_2-_Deck_the_Halls-_Christmas_WS',
    _Ornament_Puzzle: 'Ornament_Puzzle',
    _Sound_1__Jingle_Bells__Christmas_WS: 'Sound_1-_Jingle_Bells-_Christmas_WS',
}